import { observer } from 'mobx-react';
import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import MainBar from './MainBar';
import Root from './Root';
import theme from './Theme';

import AuthenticationStore from '../stores/AuthenticationStore';
import SelecaoStore from '../stores/SelecaoStore';
import UIStore from '../stores/UIStore';

import './App.css';

class App extends React.Component {
  state = { go: false, open: false };

  componentWillMount() {
    AuthenticationStore.testAuthenticated()
      .then(SelecaoStore.load)
      .then(() => this.setState({ open: false, go: true }));
    let width = this.props.width;
    UIStore.asideOpened = width === 'lg' || width === 'xl';
  }

  handleClose = () => this.setState({ open: false, go: true });

  render() {
    return (
      <CssBaseline>
        <MuiThemeProvider theme={theme}>
          <React.Fragment>
            <div
              className="page-container"
              style={{ height: 'calc(100vh - 130px )' }}
            >
              <MainBar />
              {this.state.go ? (
                <Root asideOpen={UIStore.asideOpened || UIStore.forceAside}>
                  {this.props.children}
                </Root>
              ) : (
                ''
              )}
            </div>
            <div
              style={{
                position: 'fixed',
                left: 0,
                bottom: 0,
              }}
            >
              <Typography
                style={{
                  color: theme.palette.grey[300],
                  fontSize: '0.75em',
                  fontWeight: 'bold',
                }}
              >
                {AuthenticationStore.me ? AuthenticationStore.me.id : ''}
              </Typography>
            </div>
            <div
              style={{
                position: 'fixed',
                right: 0,
                bottom: 0,
              }}
            >
              <Typography
                style={{
                  color: theme.palette.grey[500],
                  fontSize: '0.75em',
                  fontWeight: 'bold',
                }}
              >
                © 2022 Mystra Tecnologia
              </Typography>
              <Typography
                style={{
                  color: theme.palette.grey[500],
                  fontSize: '0.75em',
                  fontWeight: 'bold',
                }}
              >
                Pesquisa não registrada, não pode ser divulgada.
              </Typography>
            </div>
            <Dialog open={this.state.open} onClose={this.handleClose}>
              <DialogTitle id="alert-dialog-title">
                RODADA FINAL DE PESQUISAS
              </DialogTitle>
              <DialogContent>
                <p>
                  Estamos apresentando hoje a sexta e última rodada de pesquisas
                  sobre as Eleições 2018, que foram realizadas nos municípios do
                  Paraná. O relatório de hoje traz prognósticos indicando as
                  projeções das eleições proporcionais para a Assembleia
                  Legislativa e para a Câmara Federal. Observamos que esta
                  última rodada, realizada de segunda-feira a sexta-feira desta
                  semana, mostrou alterações significativas na opinião dos
                  eleitores em razão da movimentação final das campanhas.
                </p>
                <p>
                  A exemplo de eleições anteriores, uma parcela importante do
                  eleitorado deixou para a última semana a escolha de seus
                  candidatos. A pesquisa constatou que ainda existe uma parcela
                  de indecisos e outra mostrando que vai escolher seus
                  candidatos no momento de digitar o voto na urna eletrônica. A
                  campanha curta e concentrada em 35 dias poderá trazer
                  surpresas de última hora, o que já foi registrado também em
                  outras eleições.
                </p>
                <p>
                  O volume, o comparecimento, a ausência e o registro de votos
                  nulos e brancos podem alterar, também, a composição final da
                  divisão de vagas dos partidos e coligações. Por último,
                  informamos que a listagem da projeção com os prováveis eleitos
                  deverá ser considerada como um prognóstico, que poderá
                  registrar alterações, especialmente dos últimos colocados na
                  linha de corte das vagas que os partidos e coligações estão
                  recebendo na pesquisa.
                </p>
                <p>Alvorada Pesquisas</p>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose} color="primary" autoFocus>
                  OK
                </Button>
              </DialogActions>
            </Dialog>
          </React.Fragment>
        </MuiThemeProvider>
      </CssBaseline>
    );
  }
}

export default withWidth()(observer(App));



// WEBPACK FOOTER //
// ./src/components/App.js